import script from "./LanguageDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=4d1759c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1759c4"]])

export default __exports__